export const LOAD_LOCALE_CONFIG = 'checkout/LOAD_LOCALE_CONFIG';
export const LOAD_LOCALE_CONFIG_SUCCESS = 'checkout/LOAD_LOCALE_CONFIG_SUCCESS';
export const LOAD_LOCALE_CONFIG_FAIL = 'checkout/LOAD_LOCALE_CONFIG_FAIL';
